import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['fieldset']

  moveUp(event) {
    event.preventDefault();
    const fieldset = event.currentTarget.closest(this.fieldsetSelector);
    const previousFieldset = this.getClosestPreviousFieldset(fieldset);

    if (previousFieldset) {
      fieldset.parentNode.insertBefore(fieldset, previousFieldset);
    }
  }

  moveDown(event) {
    event.preventDefault();
    const fieldset = event.currentTarget.closest(this.fieldsetSelector);
    const nextFieldset = this.getClosestNextFieldset(fieldset);

    if (nextFieldset) {
      fieldset.parentNode.insertBefore(nextFieldset, fieldset);
    }
  }

  get fieldsetSelector() {
    return this.data.get('fieldset');
  }

  getClosestPreviousFieldset(fieldset) {
    let previousSibling = fieldset.previousElementSibling;
    while (previousSibling) {
      if (previousSibling.matches(this.fieldsetSelector)) {
        return previousSibling;
      }
      previousSibling = previousSibling.previousElementSibling;
    }
    return null;
  }

  getClosestNextFieldset(fieldset) {
    let nextSibling = fieldset.nextElementSibling;
    while (nextSibling) {
      if (nextSibling.matches(this.fieldsetSelector)) {
        return nextSibling;
      }
      nextSibling = nextSibling.nextElementSibling;
    }
    return null;
  }
}
